import React from 'react';
import { Mail, MapPin, FileText } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';

function ThirthSection() {
  const navigate = useNavigate();
  
  // Simulasi data posisi yang tersedia
  const availableJobs = []; // Kosongkan array untuk simulasi tidak ada posisi
  
  const handleEmailClick = () => {
    window.open('https://mail.google.com/mail/?view=cm&fs=1&to=papakilobarbershop@gmail.com', '_blank');
  };

  const handlePositionsClick = () => {
    if (availableJobs.length === 0) {
      const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true
        
      });

      Toast.fire({
        icon: 'warning',
        title: 'Belum ada posisi tersedia',
        text: 'Silakan cek kembali nanti'
      });
    } else {
      navigate('/jobs');
    }
  };

  const handleStoreLocationsClick = () => {
    // Handle store locations click
    console.log('Store locations clicked');
  };

  return (
    <div className="min-h-screen">
      <div className="bg-white p-8 shadow-lg rounded-2xl">
        <div className="max-w-3xl mx-auto space-y-10">
          {/* Email Section */}
          <div 
            className="flex items-center space-x-4 hover:bg-gray-50 p-4 rounded-xl transition-colors cursor-pointer"
            onClick={handleEmailClick}
          >
            <div className="bg-purple-100 p-3 rounded-full">
              <Mail className="w-8 h-8 text-purple-600" />
            </div>
            <div>
              <h2 className="text-gray-800 text-xl font-bold uppercase mb-1">Email</h2>
              <p className="text-gray-500 hover:text-purple-600 transition-colors">
                papakilobarbershop@gmail.com
              </p>
            </div>
          </div>

          {/* Head Office Section */}
          <div className="flex items-start space-x-4 p-4">
            <div className="bg-purple-100 p-3 rounded-full flex-shrink-0">
              <MapPin className="w-8 h-8 text-purple-600" />
            </div>
            <div>
              <h2 className="text-gray-800 text-xl font-bold uppercase mb-2">Head Office</h2>
              <p className="text-gray-500 leading-relaxed">
                The City Resort Residence Rukan Malibu Blok. I No.18-19,
                <br />Tower GRHA 911,
                <br />Jl. Boulevard Raya, RT.7/RW.14,
                <br />Cengkareng Timur, Kecamatan Cengkareng,
                <br />Kota Jakarta Barat, DKI Jakarta 11730
              </p>
            </div>
          </div>

          {/* Available Positions Section */}
          <div 
            className="flex items-center space-x-4 hover:bg-gray-50 p-4 rounded-xl transition-colors cursor-pointer"
            onClick={handlePositionsClick}
          >
            <div className="bg-purple-100 p-3 rounded-full">
              <FileText className="w-8 h-8 text-purple-600" />
            </div>
            <div>
              <h2 className="text-gray-800 text-xl font-bold uppercase mb-1">
                Lihat Posisi Yang Tersedia
              </h2>
              <p className="text-gray-500">Bergabunglah dengan tim kami</p>
            </div>
          </div>

          {/* Store Locations Section */}
          <div 
            className="flex items-center space-x-4 hover:bg-gray-50 p-4 rounded-xl transition-colors cursor-pointer"
            onClick={handleStoreLocationsClick}
          >
            <div className="bg-purple-100 p-3 rounded-full">
              <MapPin className="w-8 h-8 text-purple-600" />
            </div>
            <div>
              <h2 className="text-gray-800 text-xl font-bold uppercase mb-1">
                Lokasi Store Kami
              </h2>
              <p className="text-gray-500">Temukan lokasi terdekat</p>
            </div>
          </div>

          {/* Google Map Office Location */}
          <div className="rounded-xl overflow-hidden border border-gray-200">
            <iframe 
              loading="lazy"
              className="w-full h-96"
              src="https://maps.google.com/maps?q=-6.1364547563911165,106.7337168483542&t=&z=13&ie=UTF8&iwloc=&output=embed"
              title="Papakilo Hairstudio Location"
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ThirthSection;